// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608141734/js/" + chunkId + "." + {"44":"f94be46a","225":"6d1c665e","481":"1ca7add5","486":"951d888e","770":"68e7935f"}[chunkId] + ".0.8382937522783949.chunk.js";
};